import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import testStructureImg from '../../assets/img.png';
import faqImage from '../../assets/FAQs-pana.svg'

// FAQ data
const faqs = [
  {
    question: "About Opportunity Class (OC)",
    answer: (
      <>
        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">1.</span>
          <p>
            <strong>What is the Opportunity Class Placement Test?</strong><br />
            In the Australian education system — particularly in New South Wales (NSW) — an Opportunity Class (OC) is a specialised program for academically gifted students in Years 5 and 6 of primary school. These classes are offered in select public schools and aim to provide an enriched and accelerated learning environment that challenges high-performing students.
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">2.</span>
          <p>
            <strong>Why send my child to an OC school?</strong><br />
            The purpose of OCs is to nurture academic talent by providing opportunities that may not be available in regular mixed-ability classrooms, such as:
          </p>
        </div>
        <ul className="list-disc list-inside ml-8 mb-4">
          <li>Advanced curriculum</li>
          <li>Extension activities</li>
          <li>Inquiry-based learning</li>
          <li>Higher expectations and intellectual engagement</li>
        </ul>
        <div className="ml-8 mb-4">
          <p>This results in stimulating academic environment,encourages independence, resilience, and higher-order thinking. This prepares them for the exam for Selective High School entry in Year 7</p>
        </div>
        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">3.</span>
          <p>
            <strong>How can I find the nearest OC School?</strong><br />

            There are 1840 places available across 89 schools. Kindly refer to the website for the most recent listing all OC schools along with the number of seats in NSW. <a href="https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/choosing-a-school/opportunity-classes#Find2" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/choosing-a-school/opportunity-classes#Find2</a>
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">4.</span>
          <p>
            <strong>When is the exam conducted?</strong><br />
            The Opportunity Class (OC) Placement Test in New South Wales (NSW) is typically conducted once a year in early May. Its an online exam and children sit the exam when they are in Year 4. Selection is based on test results with minimum band results in each subject. There are no school assessments/ rankings submitted.
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">5.</span>
          <p>
            <strong>What is the OC Test structure?</strong><br />
            The OC test consists of:
          </p>
        </div>
        <ul className="list-disc list-inside ml-8 mb-4">
          <li>Reading comprehension</li>
          <li>Mathematical Reasoning</li>
          <li>Thinking skills (logic, pattern recognition)</li>
        </ul>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">6.</span>
          <p>
            <strong>Where can I get further information about the test?</strong><br />
            <a href="https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/choosing-a-school/opportunity-classes" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/choosing-a-school/opportunity-classes</a>
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">7.</span>
          <p>
            <strong>How do I apply for the test?</strong><br />
            To apply for entry into an Opportunity Class Primary School there is an online application form which the NSW Education Department manages. The application usually opens around late November and closes mid-January, however, this is subject to change.
          </p>
        </div>
      </>

    ),
    color: "orange",
  },
  {
    question: "About Selective High School Tests",
    answer: (
      <>
        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">1.</span>
          <p>
            <strong>What is Selective High School Tests?</strong><br />
            In New South Wales (NSW), Australia, a selective school is a public high school that admits students based on academic merit, primarily determined through a competitive examination process.
            These schools are designed to cater to high-potential and gifted students by providing an enriched and challenging educational environment.
            Exams are conducted whilst the students are in Year 6 and children commence Year 7 (High School) in Selective School (if selected).
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">2.</span>
          <p>
            <strong>When is the exam conducted?</strong><br />
            The Selective Exam Placement Test in New South Wales (NSW) is typically conducted once a year in early May.
            It's an online exam and children sit the exam when they are in Year 6.
            Selection is based on test results with minimum band results in each subject.
            There are no school assessments/ rankings submitted.
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">3.</span>
          <p>
            <strong>How much preparation is required?</strong><br />
            The NSW Department of Education emphasizes that the placement test assesses skills aligned with the Year 6 curriculum, and additional coaching is not necessary.
            However, given the competitive nature of the test—with over 15,000 applicants vying for approximately 4,000 places—many students benefit from dedicated preparation.
            A structured preparation plan might include:
          </p>
        </div>
        <ul className="list-disc list-inside ml-8 mb-4">
          <li><strong>Early Start:</strong> Begin preparation in Year 5 to build foundational skills.</li>
          <li><strong>Regular Practice:</strong> Engage in consistent practice sessions focusing on reading, mathematical reasoning, thinking skills, and writing.</li>
          <li><strong>Timed Exercises:</strong> Simulate test conditions to improve time management.</li>
          <li><strong>Review and Feedback:</strong> Analyze practice test results to identify areas for improvement.</li>
        </ul>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">4.</span>
          <p>
            <strong>What is the Selective Test Placement exam structure?</strong><br />
            The NSW Selective High School Placement Test is a competitive, computer-based examination designed to assess Year 6 students seeking entry into selective high schools for Year 7.
            As of 2025, the test structure comprises four equally weighted sections, each evaluating different skill sets.
            <div className="flex justify-center mt-4">
              <img
                src={testStructureImg}
                alt="Selective Test Structure"
                className="rounded-md shadow-md w-full max-w-lg"
              />
            </div>
          </p>
        </div>

        <div className="mb-4 flex items-start">
          <span className="text-blue-600 font-bold mr-2">5.</span>
          <p>
            <strong>Where can I get further information about the test?</strong><br />
            <a href="https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/placement-test/selective-high-school-practice-tests"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline">
              https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/placement-test/selective-high-school-practice-tests
            </a>
          </p>
        </div>
      </>
    ),
    color: "teal",
  },
  {
    question: "About ExamWarriors",
    answer: (<>
      <div className="mb-4 flex items-start">
        <span className="text-blue-600 font-bold mr-2">1.</span>
        <p>
          <strong>What is the purpose of Examwarriors?</strong><br />
          The aim of the website is to demystify the OC and the Selective exam for the parents and to provide a platform for children to practice (untimed) and give mock tests (timed) in all the core areas.
        </p>
      </div>

      <div className="mb-4 flex items-start">
        <span className="text-blue-600 font-bold mr-2">2.</span>
        <p>
          <strong>How can I track my child’s progress?</strong><br />
          Once logged in - Student Dashboard provides children/parents a very good view of their progress.
          For mock tests, the dashboard lists the topics where the child got a question wrong and where further effort is required before the next mock test.
          The Practice Questions module can be used for guidance, or you can book a meeting with one of our highly qualified tutors for further support.
        </p>
      </div>

      <div className="mb-4 flex items-start">
        <span className="text-blue-600 font-bold mr-2">3.</span>
        <p>
          <strong>My child’s scores are not improving. What can I do?</strong><br />
          Identify the areas/topics where the child is scoring low. Refer to our online Practice Questions module for practice guidance.
          If a specific concept needs to be taught or revised, book a session with our tutors.
        </p>
      </div>

      <div className="mb-4 flex items-start">
        <span className="text-blue-600 font-bold mr-2">4.</span>
        <p>
          <strong>I require further practice questions. How can Examwarriors assist?</strong><br />
          Kindly reach out to us at <a href="mailto:info@examwarriors.com.au" className="text-blue-600 underline">info@examwarriors.com.au</a> and we will revert within 24–48 working hours with a response.
        </p>
      </div>

      <div className="mb-4 flex items-start">
        <span className="text-blue-600 font-bold mr-2">5.</span>
        <p>
          <strong>Do I need to install anything?</strong><br />
          Nothing needs to be installed since it's a web application.
          We recommend using a laptop rather than a mobile phone or tablet.
          Your child requires a laptop or PC with internet access to appear for the tests and view results.
          We recommend using the Chrome browser.
        </p>
      </div>

      <div className="mb-4 flex items-start">
        <span className="text-blue-600 font-bold mr-2">6.</span>
        <div>
          <p>
            <strong>What is the Selective Test Placement exam structure?</strong><br />
            The NSW Selective High School Placement Test is a competitive, computer-based examination designed to assess Year 6 students seeking entry into selective high schools for Year 7.
            As of 2025, the test structure comprises four equally weighted sections, each evaluating different skill sets.
          </p>
        </div>
      </div>
    </>
    ),
    color: "purple",
  },
];

// Tailwind color maps
const colorMap = {
  purple: {
    text: "text-purple-800",
    bg: "bg-purple-300",
  },
  blue: {
    text: "text-blue-600",
    bg: "bg-blue-300",
  },
  yellow: {
    text: "text-yellow-500",
    bg: "bg-yellow-300",
  },
  green: {
    text: "text-green-600",
    bg: "bg-green-300",
  },
  orange: {
    text: "text-orange-500",
    bg: "bg-orange-300",
  },
  teal: {
    text: "text-teal-600",
    bg: "bg-teal-300",
  },
};

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(0); // First question open by default

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-purple-50 py-8 sm:py-12 md:py-16 px-4 sm:px-6 md:px-10">
      {/* Header Section */}
      <div className="max-w-6xl mx-auto mb-8 sm:mb-12">
        {/* <div className="items-center justify-between gap-6 sm:gap-8"> */}
          <div className="text-center">
  <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-800">
    Frequently Asked Questions
  </h2>
  <p className="mt-2 sm:mt-4 text-base sm:text-lg text-gray-500 max-w-xl mx-auto">
    Everything you need to know before getting started.
  </p>
</div>


          {/* <div className="md:flex-1 flex justify-center">
            <img
              src={faqImage}
              alt="FAQ"
              className="max-h-48 sm:max-h-56 w-auto rounded-lg sm:rounded-xl shadow-md object-contain"
            />
          </div> */}
        {/* </div> */}
      </div>

      {/* FAQ Items */}
      <div className="space-y-4 sm:space-y-6 max-w-5xl mx-auto">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const color = colorMap[faq.color];

          return (
            <div
              key={index}
              className="bg-white rounded-lg sm:rounded-xl shadow-sm sm:shadow-md transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className={`flex justify-between items-center w-full px-4 sm:px-6 py-3 sm:py-5 text-left transition duration-300 ${isOpen ? color.bg : "bg-white"
                  }`}
              >
                <span className="text-lg sm:text-xl font-semibold text-gray-900">
                  {faq.question}
                </span>
                <span className={`${color.text}`}>
                  {isOpen ? <Minus size={22} className="w-5 h-5 sm:w-6 sm:h-6" /> : <Plus size={22} className="w-5 h-5 sm:w-6 sm:h-6" />}
                </span>
              </button>
              {isOpen && (
                <div className="px-4 sm:px-6 mt-2 sm:mt-4 pb-4 sm:pb-6 text-gray-700 text-sm sm:text-base leading-relaxed bg-white">
                  {React.cloneElement(faq.answer, {
                    className: "text-sm sm:text-base" // Pass down responsive text size
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer Note */}
      <div className="mt-8 sm:mt-12 border-t pt-4 sm:pt-6 text-center text-gray-700 text-xs sm:text-sm max-w-3xl mx-auto">
        <p>
          If you haven't found a response to your question – kindly reach out to us at{" "}
          <a href="mailto:info@examwarriors.com.au" className="text-blue-600 underline">
            info@examwarriors.com.au
          </a>{" "}
          {/* and we will respond to you within 24–48 working hours. */}
        </p>
      </div>
    </div>
  );
}